// extracted by mini-css-extract-plugin
var _1 = "ClearingsInfoPanel_balanceIcon__wY4a-";
var _2 = "ClearingsInfoPanel_date__rOBiG";
var _3 = "ClearingsInfoPanel_grayColor__Z-DgR";
var _4 = "ClearingsInfoPanel_point__huirh";
export { _1 as "balanceIcon", _2 as "date", _3 as "grayColor", _4 as "point" }
